import React from 'react'

import { formatarCpf, TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaCpf = (): TabelaColuna => ({
  Chave: 'cpf',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => <span>{formatarCpf(linha.cpf)}</span>,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>CPF</div>
})
